import axios from 'axios';

export const logoutService = {
  async post(json, tokenJWT: string): Promise<any> {
    try {
      const response = await axios.post(process.env.API_LOGOUT, json, {
        headers:{
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${tokenJWT}`,
        },
        validateStatus: function (status) {
            return status >= 200 && status < 402;
        },
      });
      return response.data;
    } catch (e) {
      throw new Error(e);
    }
  }
};
